'use client';

import BN from 'bn.js';
import type { OrderActionRecord } from 'src/@types/orders';
import Tooltip from 'src/components/primitives/Tooltip/Tooltip';

function jsonReplacer(_key: string, value: unknown) {
	return BN.isBN(value) ? value.toString() : value;
}

interface DevRecordTooltipProps {
	record: OrderActionRecord;
	devSwitchIsOn: boolean;
	children: React.ReactNode;
}

/**
 * Wraps a child order action row with a devmode-only tooltip dumping the
 * raw record as JSON, matching the pattern in OpenOrdersTable.
 */
export default function DevRecordTooltip({
	record,
	devSwitchIsOn,
	children,
}: DevRecordTooltipProps) {
	if (!devSwitchIsOn) {
		return <>{children}</>;
	}

	return (
		<Tooltip
			asChild
			decoration="none"
			content={<pre>{JSON.stringify(record, jsonReplacer, 2)}</pre>}
			contentClassName="max-w-[480px] max-h-[400px] overflow-auto"
		>
			<div>{children}</div>
		</Tooltip>
	);
}
